import { defineStore } from 'pinia';
import { ref, type Ref } from 'vue';
export const useRouterStore = defineStore('router-store', () => {
  const previousPath: Ref<string> = ref('');
  return { previousPath };
});
